/*
  Ikone.

  Prej so bili povsod emojiji. Ti se na vsaki napravi narišejo drugače
  (Apple, Google in Windows imajo vsak svoj nabor), so barvni tudi tam,
  kjer barve ne želimo, in jih ni mogoče uskladiti z debelino pisave.
  Zato: en sam nabor obrisnih ikon na mreži 24×24, ki podeduje barvo
  besedila (`currentColor`) in se ravna po velikosti pisave.

  Uporaba:  <Icon name="check" />            — privzeto 20 px
            <Icon name="plane" size={28} />
            <Icon name="check" label="Potrjeno" />   — ko ikona nosi pomen

  Brez `label` je ikona za bralnik zaslona nevidna (aria-hidden), kar je
  pravilno, kadar stoji ob besedilu, ki že pove isto.
*/

const P = {
  /* navigacija */
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  plane: 'M17.8 19.2 16 11l3.5-3.5a2.1 2.1 0 0 0-3-3L13 8 4.8 6.2a.5.5 0 0 0-.5.8l3.2 3.7-2.2 2.2-2-.4a.5.5 0 0 0-.5.8L5 15.5l1.4 2.2a.5.5 0 0 0 .8-.1l2.2-2 3.7 3.2a.5.5 0 0 0 .8-.5z',
  clipboard:
    'M9 3h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 5H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 14l2 2 4-4',
  idCard:
    'M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM6 16c.5-1.5 1.7-2 3-2s2.5.5 3 2M15 10h4M15 14h3',
  users:
    'M16 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM22 20v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  mountain: 'M3 20h18L14.5 7l-3 5.5-2-3L3 20z',
  book: 'M4 4.5A2.5 2.5 0 0 1 6.5 2H20v16H6.5A2.5 2.5 0 0 0 4 20.5zM4 20.5A2.5 2.5 0 0 1 6.5 18H20v4H6.5A2.5 2.5 0 0 1 4 19.5z',

  /* stanje */
  check: 'M4 12.5 9 17.5 20 6.5',
  x: 'M6 6l12 12M18 6L6 18',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3.5 2',
  alert: 'M12 9v4.5M12 17.2v.05M10.3 3.9 2.4 17.6A1.9 1.9 0 0 0 4 20.5h16a1.9 1.9 0 0 0 1.6-2.9L13.7 3.9a1.9 1.9 0 0 0-3.4 0z',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 7.8v.05',
  award:
    'M12 14a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM8.2 13.1 7 22l5-2.5L17 22l-1.2-8.9',
  compass: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM15.5 8.5l-2 5-5 2 2-5 5-2z',

  /* dejanja */
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
  plus: 'M12 5v14M5 12h14',
  edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5z',
  trash: 'M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6',
  archive: 'M3 8h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8zM2 4h20v4H2zM10 12h4',
  download: 'M12 3v12M7 11l5 5 5-5M4 21h16',
  upload: 'M12 16V4M7 8l5-5 5 5M4 21h16',
  file: 'M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7zM14 2v5h5',
  install: 'M12 3v11M8 10l4 4 4-4M5 17v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2',
  logout: 'M15 17l5-5-5-5M20 12H9M11 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5',
  refresh: 'M20.5 12a8.5 8.5 0 1 1-2.6-6.1M20.5 4v5h-5',

  /* puščice */
  right: 'M5 12h14M13 6l6 6-6 6',
  left: 'M19 12H5M11 18l-6-6 6-6',
  up: 'M6 15l6-6 6 6',
  down: 'M6 9l6 6 6-6',

  /* stik */
  phone: 'M15.5 21A13.5 13.5 0 0 1 3 8.5 2.5 2.5 0 0 1 5.5 6h1.8a1 1 0 0 1 1 .8l.7 3a1 1 0 0 1-.3 1L7.4 12a11 11 0 0 0 4.6 4.6l1.2-1.3a1 1 0 0 1 1-.3l3 .7a1 1 0 0 1 .8 1v1.8A2.5 2.5 0 0 1 15.5 21z',
  mail: 'M3 6h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM2.5 7l9.5 6.5L21.5 7',

  /* tema */
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M21 13a9 9 0 1 1-10-10 7 7 0 0 0 10 10z',
  contrast: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 3v18',

  /* razno */
  video: 'M22 8.5 16 12l6 3.5zM3 6h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.5a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2.6-2.5 2.6M12 17.2v.05',
  wind: 'M3 8h10a3 3 0 1 0-3-3M3 16h13a3 3 0 1 1-3 3M3 12h16',
  cube: 'M12 2.5 3.5 7.2v9.6L12 21.5l8.5-4.7V7.2zM3.5 7.2 12 12l8.5-4.8M12 12v9.5',
  euro: 'M17 5.5A6.5 6.5 0 0 0 7.5 12 6.5 6.5 0 0 0 17 18.5M4 10.5h8M4 13.5h8',
  flask: 'M9 3h6M10 3v6.5L5 19a1.5 1.5 0 0 0 1.3 2.2h11.4A1.5 1.5 0 0 0 19 19l-5-9.5V3M7.5 15h9',
  note: 'M4 4h16v11l-5 5H4zM20 15h-5v5',

  /* šole in platforma */
  school: 'M3 10l9-5 9 5-9 5-9-5zM6 12v5c0 1.5 3 3 6 3s6-1.5 6-3v-5M21 10v6',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z',
  key: 'M21 2l-2 2m-7.6 7.6a5.5 5.5 0 1 1-7.8 7.8 5.5 5.5 0 0 1 7.8-7.8zm0 0L19 3.6M15.5 7.5l2 2',
  star: 'M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5L2.5 9.4l6.6-.9z',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  layers: 'M12 2.5 2.5 7.5 12 12.5l9.5-5zM2.5 12.5l9.5 5 9.5-5M2.5 17.5l9.5 5 9.5-5',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  send: 'M22 2 11 13M22 2l-7 20-4-9-9-4z',
  check2: 'M2 12.5l5 5 7-7M9 12.5l5 5 8-9',
};

/** Ikone, ki so zapolnjene in ne obrisane. */
const FILLED = new Set(['mountain']);

export function Icon({ name, size = 20, label, className, style, strokeWidth = 1.75 }) {
  const d = P[name];
  if (!d) return null;
  const filled = FILLED.has(name);

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      style={{ flexShrink: 0, display: 'block', ...style }}
    >
      <path d={d} />
    </svg>
  );
}

/** Ime ikone za stanje vaje ali leta. */
export const statusIcon = (status) =>
  status === 'confirmed' ? 'check' : status === 'rejected' ? 'x' : 'clock';
